import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { Modal, Form, Input, Button, Select, Spin } from "antd";
import { BASE_URL, callApi } from "../../api/apiCaller";
import { GreenNotify, RedNotify } from "../../helper/helper";
import routes from "../../api/routes";
import axios from "axios";
import configureAppStore from "../../redux/store";
import { DeviceUUID } from "device-uuid";
const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB chunk size

let deviceId = localStorage.getItem("deviceId");
if (!deviceId) {
  let id = new DeviceUUID().get();
  localStorage.setItem("deviceId", id);
  deviceId = id;
}

const AddVideo = ({ visible, toggleModal, recordData }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [videoName, setVideoName] = useState(null);
  const [Azerbaijani, setAudioAzerbaijani] = useState(null);
  const [Russian, setAudioRussian] = useState(null);
  const [German, setAudioGerman] = useState(null);
  const [Turkish, setAudioTurkish] = useState(null);
  const [English, setAudioEnglish] = useState(null);
  const [yogas, setYogas] = useState([]);
  const [imageError, setImageError] = useState("");
  const [videoError, setVideoError] = useState("");
  const [audioError, setAudioError] = useState("");
  const [thumbnailState, setThumbnailState] = useState(true);
  const [videoProgress, setVideoProgress] = useState(null);
  const token = configureAppStore.getState().userDataSlice.token;
  const uploadObjKey = useMemo(() => {
    return new Date().getTime();
  }, []);
  useEffect(() => {
    setVideoProgress(null);
  }, [video]);
  const handleFileUpload = useCallback(
    async (file, fileName, totalChunks, setState) => {
      try {
        // Start the timer
        const startTime = new Date();
        const myHeaders = new Headers();

        myHeaders.append("Accept", "application/json");
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", token);

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({ fileName }),
          redirect: "follow",
        };
        let res;
        try {
          res = await fetch(`${BASE_URL}initiateUpload`, requestOptions);
        } catch (error) {
          console.log(error);
          return;
        }
        const { uploadId } = await res.json();
        // Send file chunks

        const uploadPromises = [];
        let start = 0,
          end;
        const uploadHeaders = new Headers();
        uploadHeaders.append("Authorization", token);
        var uploadedChunks = 0;
        for (let i = 0; i < totalChunks; i++) {
          end = start + CHUNK_SIZE;
          const chunk = file.slice(start, end);
          const formData = new FormData();
          formData.append("index", i);
          formData.append("totalChunks", totalChunks);
          formData.append("fileName", fileName);
          formData.append("file", chunk);

          const promiseChunk = fetch(`${BASE_URL}upload?uploadId=${uploadId}`, {
            method: "POST",
            headers: uploadHeaders,
            body: formData,
          }).then(() => {
            uploadedChunks++;
            setVideoProgress(Math.floor((uploadedChunks / totalChunks) * 100));
          });
          uploadPromises.push(promiseChunk);
          start = end;
        }
        await Promise.all(uploadPromises);

        // Complete multipart upload
        const completeRes = await fetch(
          `${BASE_URL}/completeUpload?fileName=${fileName}&uploadId=${uploadId}`,
          {
            method: "POST",
            headers: myHeaders,
          }
        );
        const { success, data } = await completeRes.json();
        console.log("file link: ", data);
        setVideoProgress(null);
        setState(data);
        if (!success) {
          setVideoProgress("Video Saved");
          throw new Error("Error completing upload");
        }

        // End the timer and calculate the time elapsed
        const endTime = new Date();
        const timeElapsed = (endTime - startTime) / 1000;
        console.log("Time elapsed:", timeElapsed, "seconds");
        GreenNotify("File uploaded successfully");
        return;
      } catch (err) {
        setVideoProgress(null);
        RedNotify("Error uploading file");
      }
    },
    [token]
  );
  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const audioInputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ]; // For 5 languages
  const { Option } = Select;
  const dummyImage =
    "https://novathreadbucket.s3.amazonaws.com/nova-app-1685176470232-dummy.PNG";

  // Get token from the Redux store
  const uploadFileOnS3 = async (file, fileName) => {
    const myHeaders = new Headers();
    const formData = new FormData();
    formData.append("file", file);
    if (fileName) formData.append("fileName", fileName);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", token);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    return await new Promise((resolve, reject) => {
      fetch(`${BASE_URL}uploadFile`, requestOptions)
        .then((response) => response.json())
        .then((result) => resolve(result?.url))
        .catch((error) => reject(error));
    });
  };
  useEffect(() => {
    if (visible) {
      if (recordData) {
        console.log("record data=", recordData);
        form.setFieldsValue({
          title: recordData?.title,
          content: recordData?.content?.trim(),
          yogaId: recordData?.yogaId?._id,
        });
        setImage(recordData?.thumbnail || dummyImage);
        setVideo(recordData?.url || null);
      } else {
        form.resetFields();
        setImage(null);
        setVideo(null);
      }
    }
  }, [visible, recordData, form]);

  useEffect(() => {
    if (visible) {
      callApi(
        "GET",
        `${routes.getYogas}`,
        null,
        setIsLoading,
        (res) => {
          if (res.status === 200) {
            setYogas(res?.data?.faceYogas);
          } else {
            RedNotify("Error Occurred. Please try again later.");
          }
        },
        (error) => {
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        }
      );
    }
  }, [visible]);

  const pickFile = (isImage, isAudio = false, audioIndex = null) => {
    if (isImage) {
      imageInputRef.current.click();
    } else if (isAudio) {
      audioInputRefs[audioIndex].current.click();
    } else {
      videoInputRef.current.click();
    }
  };

  const handleFileChange = (
    event,
    isImage,
    isAudio = false,
    audioIndex = null
  ) => {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const validImageTypes = ["image/jpeg", "image/jpg", "image/png"];
      const validVideoTypes = [
        "video/mp4",
        "video/avi",
        "video/mkv",
        "video/quicktime",
      ];
      const validAudioTypes = ["audio/mpeg", "audio/wav", "audio/mp3"];

      if (isImage) {
        const file = fileList[0];
        if (!validImageTypes.includes(file.type)) {
          setImageError("Please select a valid image file (jpg, jpeg, png).");
          return;
        }
        setImage(file);
        setImageError("");
      } else if (isAudio) {
        const file = fileList[0];
        if (!validAudioTypes.includes(file.type)) {
          setAudioError(`Please select a valid audio file (mp3, wav, mpeg).`);
          return;
        }
        setAudioError("");
        switch (audioIndex) {
          case 0:
            setAudioAzerbaijani(file);
            break;
          case 1:
            setAudioRussian(file);
            break;
          case 2:
            setAudioGerman(file);
            break;
          case 3:
            setAudioTurkish(file);
            break;
          case 4:
            setAudioEnglish(file);
            break;
          default:
            break;
        }
      } else {
        const file = fileList[0];
        if (!validVideoTypes.includes(file.type)) {
          setVideoError("Please select a valid video file (mp4, avi, mkv).");
          return;
        }
        setVideo(file);
        setVideoError("");
      }
    }
  };
  const handleSave = () => {
    form.validateFields().then(async (values) => {
      const formdata = new FormData();
      formdata.append("yogaId", values.yogaId);
      formdata.append("title", values.title);
      formdata.append("content", values.content);
      if (typeof image == "string") formdata.append("thumbnail", image);
      else {
        RedNotify("Image is required");
        return;
      }
      if (videoUrl) formdata.append("video", videoUrl);
      else {
        RedNotify(
          videoProgress ? "Video is uploading..." : "Video is required"
        );
        return;
      }
      const audioFiles = { Azerbaijani, Russian, German, Turkish, English };

      function filterNullValues(obj) {
        return Object.fromEntries(
          Object.entries(obj).filter(([key, value]) => {
            return value !== null;
          })
        );
      }
      const filteredAudioFiles = filterNullValues(audioFiles);
      const entries = Object.entries(filteredAudioFiles);
      if (entries.length === 0) {
        RedNotify("Please select at least one audio file");
        return;
      } else if (entries.length === 1) {
        RedNotify("Please select at least two audio files");
        return;
      }
      setIsLoading(true);

      let audioUrls = [];

      for (let i = 0; i < entries.length; i++) {
        let [key, audio] = entries[i];

        const url = await uploadFileOnS3(
          audio,
          `raw/${uploadObjKey}/${key}.${audio.name.split(".").pop()}`
        );
        audioUrls.push(url);
      }

      formdata.append("audioUrls", JSON.stringify(audioUrls));
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
          "Upload-Key": uploadObjKey,
        },
        timeout: 1500000,
      };

      const url = recordData
        ? `${routes.updateVideo}/${recordData._id}`
        : routes.createVideo;

      const method = recordData ? axios.patch : axios.post;
      method(url, formdata, config)
        .then((response) => {
          GreenNotify(
            recordData
              ? "Video updated successfully"
              : "Video created successfully"
          );
          toggleModal();
        })
        .catch((error) => {
          console.error("Error Details:", error.toJSON());
          RedNotify("An error occurred. Please try again.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    });
  };

  const getImagePreview = () => {
    if (image instanceof File) {
      return URL.createObjectURL(image);
    }
    return image || dummyImage;
  };

  const getVideoPreview = () => {
    if (video instanceof File) {
      return URL.createObjectURL(video);
    }
    return video || null;
  };

  return (
    <Modal
      title={recordData ? "Update Video" : "Create Video"}
      visible={visible}
      onCancel={toggleModal}
      footer={null}
    >
      {isLoading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100px",
          }}
        >
          <Spin size="large" />
          <p style={{ marginTop: "10px" }}>
            Processing the video, please wait...
          </p>
        </div>
      ) : (
        <Form form={form} layout="vertical">
          <Form.Item
            label="FaceYoga"
            name="yogaId"
            rules={[{ required: true, message: "Please select a category" }]}
          >
            <Select placeholder="Select FaceYoga">
              {yogas.map((yoga) => (
                <Option key={yoga._id} value={yoga._id}>
                  {yoga.title}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: "Please enter the title" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Content"
            name="content"
            rules={[{ required: true, message: "Please enter content" }]}
          >
            <Input.TextArea autoSize />
          </Form.Item>

          {/* Image Upload */}
          <Form.Item label="Thumbnail">
            <Button
              type="dashed"
              onClick={() => pickFile(true)}
              style={{ width: "100%" }}
            >
              {image ? "Change Thumbnail" : "Upload Thumbnail"}
            </Button>
            <input
              ref={imageInputRef}
              type="file"
              style={{ display: "none" }}
              onChange={(event) => handleFileChange(event, true)}
              accept="image/*"
            />

            {imageError && <p style={{ color: "red" }}>{imageError}</p>}
            {image && (
              <>
                <img
                  src={getImagePreview()}
                  alt="Thumbnail"
                  style={{ width: "100%", height: "170px", marginTop: "10px" }}
                />
                <Button
                  onClick={async () => {
                    try {
                      setThumbnailState(false);
                      const url = await uploadFileOnS3(image);
                      setImage(url);
                      GreenNotify("Thumbnail updated successfully");
                      setThumbnailState(true);
                    } catch (error) {
                      RedNotify("An error occurred. Please try again.");
                    }
                  }}
                  type="primary"
                  disabled={
                    !(image && typeof image !== "string" && thumbnailState)
                  }
                  style={{ width: "100%" }}
                >
                  {image && typeof image === "string"
                    ? "Image Saved"
                    : !thumbnailState
                    ? "Loading..."
                    : "Save Image"}
                </Button>
              </>
            )}
          </Form.Item>

          <Form.Item label="Video">
            <Button
              type="dashed"
              onClick={() => pickFile(false)}
              style={{ width: "100%" }}
            >
              {video ? "Change Video" : "Upload Video"}
            </Button>
            <input
              ref={videoInputRef}
              type="file"
              style={{ display: "none" }}
              onChange={(e) => {
                const file = e.target.files[0];
                setVideo(file);
                setVideoName("raw/" + uploadObjKey + "/" + file.name);
              }}
              accept="video/*"
            />
            {videoError && <p style={{ color: "red" }}>{videoError}</p>}
            {video && (
              <>
                <video
                  src={getVideoPreview()}
                  controls
                  style={{ width: "100%", height: "170px", marginTop: "10px" }}
                />
                <Button
                  disabled={videoProgress !== null}
                  onClick={async () => {
                    try {
                      setVideoProgress("Processing..");
                      handleFileUpload(
                        video,
                        videoName,
                        Math.ceil(video.size / CHUNK_SIZE),
                        setVideoUrl
                      );
                    } catch (error) {
                      RedNotify("An error occurred. Please try again.");
                    }
                  }}
                  type="primary"
                  style={{
                    width: "100%",
                    color: videoProgress == null ? "white" : "black",
                  }}
                >
                  {videoProgress
                    ? `${
                        typeof videoProgress == "number"
                          ? `Upload Progress: ${videoProgress}%`
                          : videoProgress
                      } `
                    : !videoUrl
                    ? "Save Video"
                    : "Video Saved"}
                </Button>
              </>
            )}
          </Form.Item>

          {/* Audio Uploads */}
          <Form.Item label="Audio Files">
            <Button
              type="dashed"
              onClick={() => pickFile(false, true, 0)}
              style={{ width: "100%", marginBottom: "10px" }}
            >
              {Azerbaijani
                ? "Change Azerbaijani Audio"
                : "Upload Azerbaijani Audio"}
            </Button>
            <Button
              type="dashed"
              onClick={() => pickFile(false, true, 1)}
              style={{ width: "100%", marginBottom: "10px" }}
            >
              {Russian ? "Change Russian Audio" : "Upload Russian Audio"}
            </Button>
            <Button
              type="dashed"
              onClick={() => pickFile(false, true, 2)}
              style={{ width: "100%", marginBottom: "10px" }}
            >
              {German ? "Change German Audio" : "Upload German Audio"}
            </Button>
            <Button
              type="dashed"
              onClick={() => pickFile(false, true, 3)}
              style={{ width: "100%", marginBottom: "10px" }}
            >
              {Turkish ? "Change Turkish Audio" : "Upload Turkish Audio"}
            </Button>
            <Button
              type="dashed"
              onClick={() => pickFile(false, true, 4)}
              style={{ width: "100%", marginBottom: "10px" }}
            >
              {English ? "Change English Audio" : "Upload English Audio"}
            </Button>
            {audioError && <p style={{ color: "red" }}>{audioError}</p>}
            <input
              ref={audioInputRefs[0]}
              type="file"
              style={{ display: "none" }}
              onChange={(event) => handleFileChange(event, false, true, 0)}
              accept="audio/*"
            />
            <input
              ref={audioInputRefs[1]}
              type="file"
              style={{ display: "none" }}
              onChange={(event) => handleFileChange(event, false, true, 1)}
              accept="audio/*"
            />
            <input
              ref={audioInputRefs[2]}
              type="file"
              style={{ display: "none" }}
              onChange={(event) => handleFileChange(event, false, true, 2)}
              accept="audio/*"
            />
            <input
              ref={audioInputRefs[3]}
              type="file"
              style={{ display: "none" }}
              onChange={(event) => handleFileChange(event, false, true, 3)}
              accept="audio/*"
            />
            <input
              ref={audioInputRefs[4]}
              type="file"
              style={{ display: "none" }}
              onChange={(event) => handleFileChange(event, false, true, 4)}
              accept="audio/*"
            />
          </Form.Item>

          <Button type="primary" onClick={handleSave} style={{ width: "100%" }}>
            {recordData ? "Update Video" : "Create Video"}
          </Button>
        </Form>
      )}
    </Modal>
  );
};

export default AddVideo;
